import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Carnitas',
  source: 'https://www.seriouseats.com/sous-vide-carnitas-crispy-mexican-style-pulled-pork-recipe',
  totalTime: time(24, 25),
  servings: 12,
  tags: { type: 'main' },
  vessels: { main: { kind: 'skillet', diameter: 12 } },
  ingredients: [
    { name: 'pork shoulder', quantity: '4', unit: 'lb',
      note: 'boneless, cut into 2-in thick slabs',
    },
    { name: 'onion', quantity: '1',
      note: 'medium, roughly chopped',
    },
    { name: 'garlic', quantity: '6', unit: 'cloves', customUnit: true },
    { name: 'cinnamon stick', quantity: '1',
      note: 'broken into 3–4 pieces',
    },
    { name: 'orange', quantity: '1',
      note: 'medium, peel intact',
    },
    { name: 'kosher salt' },
    { name: 'black pepper' },
    { name: 'corn tortillas',
      note: 'warmed',
    },
    { name: 'lime wedges' },
    { name: 'white onion',
      note: 'chopped',
    },
    { name: 'fresh cilantro',
      note: 'chopped leaves',
    },
    { name: 'salsa verde',
      note: 'charred',
    },
  ],
  directions: [
    {
      title: 'Marinate',
      bullets: [
        "Season {pork shoulder} generously on all sides with {kosher salt} & {black pepper}",
        "Divide pork between {=2} gallon zipper-lock bags, laying slabs flat in single layer",
        "Split {onion}, {garlic} & {cinnamon stick} evenly between bags",
        "Quarter {orange}, squeeze juice into bags, then add squeezed quarters",
        "Massage bags to distribute seasoning",
      ],
    },
    {
      title: 'Sous vide',
      bullets: [
        "Lower bags into bath, letting water press out air, then seal fully",
        "Cook at {!165F} for 24h",
      ],
    },
    {
      title: 'Shred',
      bullets: [
        "Remove bags from bath & transfer meat to tray, reserving cooking liquid",
        "Shred roughly with 2 forks",
      ],
    },
    {
      title: 'Crisp',
      bullets: [
        "Heat {vessel} over medium-high",
        "Add shredded meat in even layer & pour reserved cooking liquid back over",
        "Cook undisturbed until bottom is dark brown & crisp",
        "Flip & move meat around to crisp several sides — finished carnitas should be a mix of crisp & soft throughout",
      ],
    },
    {
      title: 'Serve',
      bullets: [
        "Serve carnitas with {corn tortillas}, {lime wedges}, {white onion}, {fresh cilantro} & {salsa verde}",
      ],
    },
  ],
};

export default recipe;
